/*! Divine Hindu picks on blog articles \u00b7 v1 \u00b7 16 Oct 2026
 * Places Divine Hindu's own product suggestions in every article, in eight formats:
 *   s  search-style text unit      n  in-article product card     r  related searches
 *   v  motion or video unit        m  product grid                a  bar at the bottom of the screen
 *   p  gentle pop-up               l  side panel on wide screens
 * Data comes from sections/dh-blog-picks.liquid (#dhbp-data). Every unit says it is Divine Hindu's own.
 * Class names use the dhbp- prefix and avoid the words ad, banner, sponsor and promo, which ad blockers hide.
 */
(function () {
  'use strict';
  if (window.__dhbp) return;
  var dataEl = document.getElementById('dhbp-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  window.__dhbp = { v: 1, state: 'start' };

  const doc = document, win = window, html = doc.documentElement;
  const CFG = D.cfg || {}, ROUTES = D.routes || {}, ART = D.a || {};
  const LABEL = (CFG.label || 'Sponsored').trim() || 'Sponsored';
  const OFFER = (CFG.offer || '').trim();
  const REDUCED = !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const SAVE = !!(navigator.connection && navigator.connection.saveData);
  const IST = 5.5 * 36e5;
  const T0 = Date.now();
  const FN = { s: 'search', n: 'card', r: 'related', v: 'video', m: 'grid', a: 'bar', p: 'popup', l: 'panel' };
  const store = {
    get(k) { try { return win.sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { win.sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };

  /* ---------- small helpers ---------- */
  const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ESC[c]);
  const ta = doc.createElement('textarea');
  const deco = s => { ta.innerHTML = String(s == null ? '' : s); return ta.value; };
  const money = r => '\u20b9' + Math.round(r).toLocaleString('en-IN');
  const sized = (u, w) => !u ? '' : (/[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w);
  const link = (u, f) => {
    if (!u) return '#';
    let b = u.split('#')[0].replace(/([?&])(_pos|_sid|_ss|_psq|_psid|_fid|_v)=[^&]*/g, '$1').replace(/&{2,}/g, '&').replace(/\?&/, '?').replace(/[?&]+$/, '');
    return b + (b.indexOf('?') < 0 ? '?' : '&') + 'dh_src=blog-' + f;
  };
  const imgTag = (u, ws, sizes, cls) => !u ? '' :
    `<img class="${cls || ''}" src="${esc(sized(u, ws[ws.length - 1]))}" srcset="${esc(ws.map(w => sized(u, w) + ' ' + w + 'w').join(', '))}" sizes="${esc(sizes)}" alt="" loading="lazy" decoding="async">`;
  const cut = (t, max) => !max || t.length <= max ? t : t.slice(0, max - 1).replace(/[\s,;:&\-\u2013\u2014]+\S*$/, '') + '\u2026';
  const sentence = (s, max) => {
    s = deco(s || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    const m = s.match(/^(.{30,}?[.!?])(?=\s|[A-Z]|$)/);
    return cut(m ? m[1] : s, max);
  };

  /* ---------- products ---------- */
  const PUJA_TYPE = /\b(puja|pooja|seva)\b/i;
  const fromL = o => ({
    id: String(o.id), t: deco(o.t || ''), u: o.u || '', p: (+o.p || 0) / 100, c: (+o.c || 0) / 100, ty: o.ty || '', g: !!o.g,
    i: o.i || '', x: o.x || [], v: o.v || '', vp: o.vp || '', d: o.d || '', col: o.col || '', free: !!o.free, cta: o.cta || ''
  });
  const fromS = o => {
    const tags = o.tags || [];
    const im = (o.featured_image && o.featured_image.url) || o.image || '';
    const p = parseFloat(o.price) || 0, c = parseFloat(o.compare_at_price_min) || 0;
    return {
      id: String(o.id), t: deco(o.title || ''), u: o.url || '', p, c: c > p ? c : 0, ty: o.type || '',
      g: PUJA_TYPE.test(o.type || '') || tags.indexOf('pooja-seva') >= 0, i: im ? sized(im, 720) : '', x: [], v: '', vp: '',
      d: String(o.body || '').replace(/<[^>]+>/g, ' ').slice(0, 400), col: '', free: false, cta: '', s: 1
    };
  };
  const MON = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  function stale(t) {
    // listings with a date in the title stop showing from 4 PM (IST) the day before that date; past years too
    const now = Date.now(), yNow = new Date(now + IST).getUTCFullYear(), dates = [];
    let m;
    const a = /(\d{1,2})(?:st|nd|rd|th)?\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?,?\s+(20\d\d)/ig;
    while ((m = a.exec(t))) dates.push([+m[3], MON[m[2].toLowerCase()], +m[1]]);
    const b = /(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(20\d\d)/ig;
    while ((m = b.exec(t))) dates.push([+m[3], MON[m[1].toLowerCase()], +m[2]]);
    for (const d of dates) if (now >= Date.UTC(d[0], d[1], d[2]) - IST - 8 * 36e5) return true;
    if (!dates.length) { const ys = t.match(/\b20\d\d\b/g); if (ys && ys.every(y => +y < yNow)) return true; }
    return false;
  }
  const usable = p => !!(p && p.id && p.u && p.i && p.t) && (p.free || p.p > 0) && !/\badd[\s-]?ons?\b|gift card/i.test(p.t) && !stale(p.t);

  const ITEMS = new Map();
  (D.items || []).forEach(o => { const p = fromL(o); if (usable(p)) ITEMS.set(p.id, p); });
  const TOPICS = (D.topics || []).map(t => ({
    k: t.k, l: t.l || '', h: t.h || '', d: t.d || '', lead: (t.lead || []).map(String),
    cols: (t.cols || []).filter(c => c && c.u).map(c => ({ h: c.h, l: c.l, u: c.u, ids: (c.ids || []).map(String) }))
  }));
  const T1 = TOPICS[0] || null;
  const T2 = TOPICS.find((t, i) => i > 0 && t.k !== 'default') || null;
  const rr = t => {
    const out = t.lead.slice(), lists = t.cols.map(c => c.ids.slice());
    let more = true;
    while (more) { more = false; lists.forEach(L => { if (L.length) { out.push(L.shift()); more = true; } }); }
    return out;
  };

  /* ---------- products named in the article (store search) ---------- */
  const STOP = new Set(('a an and are as at be by can do does for from how in into is it its of on or the to vs what when where which who why with your you our this that these those ' +
    'puja pooja vidhi date dates significance benefit benefits meaning meanings guide guides complete full step steps rule rules tip tips explained best top list all day days time timing times story history ' +
    'festival festivals hindu hinduism india indian online book booking offer offering perform performing arrange sponsor recite chant chanting prepare preparing preparation choose choosing understanding ' +
    'traditional tradition traditions family families questions question faq faqs common practical home real fake original versus new about remedies remedy effects effect results result ' +
    'signs sign causes cause types type use uses using wear wearing care should must need know get make makes made way ways').split(/\s+/));
  const words = s => deco(s || '').toLowerCase().replace(/[^a-z0-9\u0900-\u0dff\s]/g, ' ').split(/\s+/).filter(w => w.length >= 3 && !STOP.has(w) && !/^\d+$/.test(w));
  function queries() {
    const out = [];
    const hw = words(String(ART.t || '').split(/[:?|\u2014\u2013(]/)[0]).slice(0, 4);
    if (hw.length) out.push(hw);
    const GENERIC = /^(puja guides?|hindu (festivals?|gods|culture|mythology|rituals|traditions)|festivals?|festival guide|spirituality|guide|essentials|remedies|mantra|gemstones?|pooja|puja vidhi|vedic wisdom|spiritual( practice| jewellery| beads| mala)?|buying guide)$/i;
    const titleW = new Set(words(ART.t || ''));
    let best = null, score = -1;
    (ART.tags || []).forEach(tag => {
      if (GENERIC.test(String(tag).trim())) return;
      const tw = words(tag);
      if (!tw.length || tw.length > 4) return;
      const sc = tw.filter(w => titleW.has(w)).length * 2 + (tw.length > 1 ? 1 : 0);
      if (sc > score) { score = sc; best = tw; }
    });
    if (best && !(hw.length && best.every(w => hw.indexOf(w) >= 0))) out.push(best);
    return out.slice(0, 2);
  }
  function suggest(qw) {
    const base = (ROUTES.suggest || '/search/suggest').replace(/\/$/, '');
    const url = base + '.json?q=' + encodeURIComponent(qw.join(' ')) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,tag';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(r => (r.ok ? r.json() : null))
      .then(j => {
        const ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        return ps.map(o => {
          const p = fromS(o), tw = new Set(words(p.t));
          p.hit = qw.filter(w => tw.has(w)).length;
          return p;
        }).filter(p => p.hit > 0).sort((a, b) => b.hit - a.hit);
      })
      .catch(() => []);
  }

  /* ---------- the pool, in order of relevance ---------- */
  let POOL = [], BY = new Map(), SHARE = 0;
  function buildPool(hits) {
    const seen = new Set();
    const add = p => { if (p && !seen.has(p.id) && usable(p)) { seen.add(p.id); POOL.push(p); BY.set(p.id, p); } };
    if (T1) T1.lead.forEach(id => add(ITEMS.get(id)));
    (hits || []).slice(0, 8).forEach(p => add(ITEMS.get(p.id) || p));
    TOPICS.forEach(t => rr(t).forEach(id => add(ITEMS.get(id))));
    ITEMS.forEach(add);
    const top = POOL.slice(0, 12);
    SHARE = top.length ? top.filter(p => p.g).length / top.length : 0;
  }
  const used = new Map();
  function pickNear(n, pred, span) {   // prefer pred, but only among the next few closest matches
    const near = POOL.filter(p => !used.has(p.id)).slice(0, span);
    const first = near.find(p => pred(p));
    if (!first) return pick(n);
    used.set(first.id, (used.get(first.id) || 0) + 1);
    return [first].concat(pick(n - 1));
  }
  function pickPrefer(n, pred, span) {   // up to n from the next few closest matches that fit pred, then the rest in order
    const got = POOL.filter(p => !used.has(p.id)).slice(0, span).filter(pred).slice(0, n);
    got.forEach(p => used.set(p.id, (used.get(p.id) || 0) + 1));
    return got.concat(pick(n - got.length));
  }
  function pick(n, pred) {
    const out = [];
    const take = p => { out.push(p); used.set(p.id, (used.get(p.id) || 0) + 1); };
    for (const p of POOL) { if (out.length >= n) break; if (!used.has(p.id) && (!pred || pred(p))) take(p); }
    for (const p of POOL) { if (out.length >= n) break; if (!used.has(p.id) && out.indexOf(p) < 0) take(p); }
    if (out.length < n) {
      const rest = POOL.filter(p => out.indexOf(p) < 0 && (!pred || pred(p))).concat(POOL.filter(p => out.indexOf(p) < 0 && pred && !pred(p)))
        .sort((a, b) => (used.get(a.id) || 0) - (used.get(b.id) || 0));
      while (out.length < n && rest.length) take(rest.shift());
    }
    return out;
  }

  /* ---------- wording ---------- */
  const pujaLed = () => SHARE >= 0.7;
  const goodsLed = () => SHARE <= 0.3;
  const trustLine = () => pujaLed() ? 'Booked online with your name and gotra in the sankalp.' :
    goodsLed() ? 'Delivery across India \u00b7 Cash on delivery available.' : 'Delivery across India \u00b7 Pujas booked in your name and gotra.';
  const itemTrust = p => p.free ? 'Free scan from a photo of your palm' : p.g ? 'Your name and gotra in the sankalp' : 'Delivery across India \u00b7 COD available';
  const shortT = (p, max) => {
    let t = p.t.replace(/\s+/g, ' ').trim();
    if (!p.g) t = t.split(' | ')[0].replace(/\s*[-\u2013\u2014]\s*divine hindu.*$/i, '').replace(/^divine hindu\s+(?=\S)/i, '');
    return cut(t, max);
  };
  const phrase = p => {
    let t = p.t.replace(/\s+/g, ' ').trim();
    if (p.g) {
      const parts = t.split(/\s+[\u2014\u2013]\s+/);
      const name = parts[0];
      const place = parts[1] && !/\d/.test(parts[1]) ? parts[1].split(',').pop().trim() : '';
      t = place && name.toLowerCase().indexOf(place.toLowerCase()) < 0 ? name + ' at ' + place : name;
    } else {
      t = t.split(' | ')[0].replace(/\s*\([^)]*\)/g, '').replace(/\s+(with|for)\s+.*$/i, '');
    }
    return cut(t, 64);
  };
  const off = p => (p.c > p.p && p.p > 0 ? Math.round((1 - p.p / p.c) * 100) : 0);
  const priceHTML = p => p.free ? '<b class="dhbp-pr">Free</b>' :
    `<b class="dhbp-pr">${money(p.p)}</b>` + (p.c > p.p ? `<s class="dhbp-was">${money(p.c)}</s>` : '');
  const cta = p => p.free ? (p.cta || 'Scan free') : p.g ? 'Book now' : 'Shop now';
  const FAV = (() => { const l = doc.querySelector('link[rel~="icon"]'); return l ? l.href : ''; })();
  const WHY = 'This is Divine Hindu\u2019s own suggestion, picked for this article. We do not show other companies\u2019 ads.';
  const tag = () => `<div class="dhbp-tag"><b>${esc(LABEL)}</b><span>\u00b7 Divine Hindu</span><button type="button" class="dhbp-i" aria-label="About this suggestion" aria-expanded="false">i</button></div><div class="dhbp-why" hidden>${esc(WHY)}</div>`;
  const ids = ps => ps.map(p => p.id).join(',');
  const kickerFor = p => { const t = TOPICS.find(t => t.cols.some(c => c.h === p.col)); return t ? t.l : (T1 ? T1.l : 'Divine Hindu'); };

  /* ---------- the eight formats ---------- */
  function unitS(topic, prods) {
    const cols = topic ? topic.cols : [];
    const first = cols[0] || null, lead = prods[0];
    const head = topic ? topic.h : shortT(lead, 70) + ' | Divine Hindu';
    const href = first ? link(first.u, 's') : link(lead.u, 's');
    const hid = first ? 'c:' + first.h : lead.id;
    const crumb = 'www.divinehindu.in \u203a ' + (first ? first.h.replace(/-/g, ' ') : 'products');
    const desc = topic ? topic.d : sentence(lead.d, 130);
    const sl = [];
    cols.slice(0, 4).forEach(c => sl.push(`<a href="${esc(link(c.u, 's'))}" data-id="c:${esc(c.h)}">${esc(c.l)}</a>`));
    for (let i = topic ? 0 : 1; sl.length < 4 && i < prods.length; i++) sl.push(`<a href="${esc(link(prods[i].u, 's'))}" data-id="${esc(prods[i].id)}">${esc(shortT(prods[i], 30))}</a>`);
    return `<div class="dhbp-s"><div class="dhbp-s__top">${esc(LABEL)}</div>
<div class="dhbp-s__site"><span class="dhbp-s__fav"${FAV ? ` style="background-image:url('${esc(FAV)}')"` : ''}></span><span class="dhbp-s__who"><span class="dhbp-s__name">Divine Hindu</span><span class="dhbp-s__url">${esc(crumb)}</span></span><button type="button" class="dhbp-i dhbp-s__dots" aria-label="About this suggestion" aria-expanded="false">\u22ee</button></div>
<div class="dhbp-why" hidden>${esc(WHY)}</div>
<a class="dhbp-s__h" href="${esc(href)}" data-id="${esc(hid)}">${esc(head)}</a>
<p class="dhbp-s__d">${esc(desc)} <b>${esc(trustLine())}</b></p>
<div class="dhbp-s__links">${sl.join('')}</div></div>`;
  }
  function unitN(p, kicker) {
    const o = off(p), pill = p.free ? 'Free' : o >= 10 ? o + '% off' : p.g ? 'Book online' : '';
    const u = esc(link(p.u, 'n')), id = esc(p.id);
    return `<div class="dhbp-n">${tag()}<a class="dhbp-n__img" href="${u}" data-id="${id}" tabindex="-1" aria-hidden="true">${imgTag(p.i, [360, 540, 720], '(min-width: 700px) 300px, 92vw')}${pill ? `<span class="dhbp-n__pill">${esc(pill)}</span>` : ''}</a>
<div class="dhbp-n__b"><div class="dhbp-n__k">${esc(kicker)}</div><a class="dhbp-n__t" href="${u}" data-id="${id}">${esc(shortT(p, 96))}</a>
<p class="dhbp-n__d">${esc(sentence(p.d, 140))}</p>
<div class="dhbp-n__row"><div class="dhbp-n__p">${priceHTML(p)}</div><a class="dhbp-btn" href="${u}" data-id="${id}">${esc(cta(p))}</a></div>
<div class="dhbp-n__tr">${esc(itemTrust(p))}</div></div></div>`;
  }
  function unitR(prods) {
    return `<div class="dhbp-r"><div class="dhbp-r__top"><b>Related searches</b><span>${esc(LABEL)} \u00b7 Divine Hindu</span></div>${prods.map(p =>
      `<a href="${esc(link(p.u, 'r'))}" data-id="${esc(p.id)}"><span>${esc(phrase(p))}</span></a>`).join('')}</div>`;
  }
  function unitV(prods) {
    const main = prods[0];
    let frame, mode, slides = [];
    if (main.v && !SAVE) {
      mode = 'video';
      frame = `<video class="dhbp-v__vid" muted playsinline loop preload="none" disablepictureinpicture disableremoteplayback poster="${esc(sized(main.vp || main.i, 720))}" src="${esc(main.v)}" aria-hidden="true"></video>`;
    } else {
      mode = 'slides';
      if (main.x.length >= 2) slides = [main.i].concat(main.x.slice(0, 3)).map(i => ({ i, p: main }));
      else slides = prods.slice(0, 4).map(p => ({ i: p.i, p }));
      frame = slides.map((s, k) => `<span class="dhbp-v__sl${k ? '' : ' is-on'}" data-k="${k}">${imgTag(s.i, [480, 720], '(min-width: 760px) 720px, 92vw')}</span>`).join('');
    }
    const cap = main.free ? 'Free palm scan from a photo of your hand' : kickerFor(main);
    const segs = mode === 'slides' && slides.length > 1 ? `<span class="dhbp-v__prog">${slides.map((s, k) => `<i data-k="${k}"></i>`).join('')}</span>` : '<span class="dhbp-v__prog dhbp-v__prog--one"><i></i></span>';
    const u = esc(link(main.u, 'v')), id = esc(main.id);
    const el = `<div class="dhbp-v" data-mode="${mode}"><div class="dhbp-tag dhbp-tag--dark"><b>${esc(LABEL)}</b><span>\u00b7 Divine Hindu</span><button type="button" class="dhbp-i" aria-label="About this suggestion" aria-expanded="false">i</button></div><div class="dhbp-why" hidden>${esc(WHY)}</div>
<a class="dhbp-v__f" href="${u}" data-id="${id}">${frame}<span class="dhbp-v__cap">${esc(cap)}</span>${segs}</a>
<div class="dhbp-v__bar"><span class="dhbp-v__th">${imgTag(main.i, [120, 180], '48px')}</span><span class="dhbp-v__tx"><b>${esc(shortT(main, 70))}</b><span>${priceHTML(main)}</span></span><a class="dhbp-btn" href="${u}" data-id="${id}">${esc(cta(main))}</a></div></div>`;
    return { html: el, slides };
  }
  function unitM(prods, topic) {
    const col = topic && topic.cols[0];
    const head = topic ? topic.l : 'Picked for this article';
    return `<div class="dhbp-m"><div class="dhbp-m__top"><b>${esc(head)}</b><span>${esc(LABEL)} \u00b7 Divine Hindu</span></div>
<div class="dhbp-m__g">${prods.map(p => {
      const o = off(p);
      return `<a class="dhbp-m__c" href="${esc(link(p.u, 'm'))}" data-id="${esc(p.id)}"><span class="dhbp-m__im">${imgTag(p.i, [240, 360, 480], '(min-width: 760px) 180px, 45vw')}${o >= 10 ? `<i>${o}% off</i>` : p.free ? '<i>Free</i>' : ''}</span><span class="dhbp-m__t">${esc(shortT(p, 72))}</span><span class="dhbp-m__p">${priceHTML(p)}</span></a>`;
    }).join('')}</div>${col ? `<a class="dhbp-m__all" href="${esc(link(col.u, 'm'))}" data-id="c:${esc(col.h)}">See all: ${esc(col.l)} \u203a</a>` : ''}</div>`;
  }

  /* ---------- reading the article ---------- */
  const SKIP = /^(SCRIPT|STYLE|TEMPLATE|LINK|META|NOSCRIPT|BR|HR)$/;
  const wc = el => { const t = (el.innerText || '').trim(); return t ? t.split(/\s+/).length : 0; };
  function findRoot() {
    const rte = doc.querySelector('.shopify-section[id*="__main"] .rte') || doc.querySelector('main .rte') || doc.querySelector('.rte');
    if (!rte) return null;
    let root = rte;
    for (let d = 0; d < 4; d++) {
      const total = wc(root) || 1;
      let big = null;
      for (const k of root.children) {
        if (SKIP.test(k.tagName)) continue;
        if (wc(k) / total > 0.6 && k.children.length >= 4) { big = k; break; }
      }
      if (!big) break;
      root = big;
    }
    return { rte, root };
  }
  function kindOf(el, i) {
    const tn = el.tagName, cls = typeof el.className === 'string' ? el.className : '';
    if (SKIP.test(tn)) return 'x';
    if (/\bdhbp-/.test(cls)) return 'u';
    if (/^H[1-6]$/.test(tn)) return 'h';
    if (tn === 'ASIDE' || /author-bio/.test(cls)) return 'bio';
    if (/(credit|directory-link|dh-meta)/.test(cls)) return 'meta';
    const txt = (el.innerText || '').trim();
    if (!txt && !el.querySelector('img,picture,iframe,video,table,svg')) return 'x';
    if (txt.length < 500 && !/^(P|UL|OL|BLOCKQUOTE|TABLE)$/.test(tn) && el.querySelector('a[href*="/products/"],a[href*="/collections/"],a[href*="/pages/"],button')) return 'promo';
    if (/divine hindu app/i.test(txt) && txt.length < 500) return 'promo';
    if (tn === 'NAV') return 'nav';
    return 'b';
  }
  function plan(info) {
    const { rte, root } = info;
    const kids = Array.prototype.slice.call(root.children);
    const kinds = kids.map(kindOf), wcs = kids.map(k => (SKIP.test(k.tagName) ? 0 : wc(k)));
    let start = 0;
    if (root === rte) {
      while (start < kids.length && start < 6) {
        const k = kids[start], tn = k.tagName;
        if (tn === 'H1' || kinds[start] === 'x' || kinds[start] === 'meta' || (/^(IMG|PICTURE|FIGURE)$/.test(tn) && start < 4) ||
          (tn === 'P' && start <= 2 && /(published|updated)/i.test(k.innerText || ''))) start++;
        else break;
      }
    }
    while (start < kids.length && (kinds[start] === 'meta' || kinds[start] === 'x')) start++;
    let end = kids.length;
    while (end > start && /^(x|bio|meta|promo|u)$/.test(kinds[end - 1])) end--;
    const FAQ = /(frequently asked|\bfaqs?\b|common questions|common practical questions|questions before|your questions)/i;
    let faq = -1;
    for (let i = start + 3; i < end; i++) if (kinds[i] === 'h' && /^H[23]$/.test(kids[i].tagName) && FAQ.test(kids[i].innerText || '')) { faq = i; break; }
    const mainEnd = faq > 0 ? faq : end;
    const wAt = [0];
    for (let i = 0; i < kids.length; i++) wAt.push(wAt[i] + (i >= start && i < mainEnd && kinds[i] === 'b' ? wcs[i] : 0));
    const blocksBefore = i => { let n = 0; for (let j = start; j < i; j++) if (kinds[j] === 'b') n++; return n; };
    const ok = i => {
      if (i <= start || i > mainEnd) return false;
      const pk = kinds[i - 1], nk = i < kids.length ? kinds[i] : 'end';
      if (pk === 'h' || pk === 'promo' || pk === 'u' || pk === 'nav' || pk === 'meta') return false;
      if (nk === 'promo' || nk === 'u') return false;
      if (/[:\uff1a]\s*$/.test((kids[i - 1].innerText || '').trim())) return false;
      return wAt[i] >= 30;
    };
    const W = wAt[mainEnd];
    const N = Math.max(5, Math.min(12, 5 + Math.floor(Math.max(0, W - 1000) / 400)));
    const gaps = [];
    for (let i = start + 1; i <= mainEnd; i++) if (ok(i)) gaps.push(i);
    let g1 = -1;
    const tl = kids.findIndex(k => k.classList && k.classList.contains('dh-tldr'));
    if (tl >= start && ok(tl + 1)) g1 = tl + 1;
    if (g1 < 0) { const f = gaps.find(i => wAt[i] >= Math.min(110, W * 0.12) && blocksBefore(i) >= 2); g1 = f != null ? f : (gaps[0] != null ? gaps[0] : -1); }
    let gE = ok(mainEnd) ? mainEnd : gaps.filter(i => i > g1).pop();
    if (gE == null || gE < g1) gE = g1;
    const chosen = [];
    if (g1 >= 0) {
      chosen.push(g1);
      if (gE > g1) {
        const span = wAt[gE] - wAt[g1], minW = Math.max(70, span / (N - 1) * 0.45);
        for (let k = 1; k <= N - 2; k++) {
          const t = wAt[g1] + span * k / (N - 1);
          let best = -1, bs = 1e9;
          for (const i of gaps) {
            if (i <= g1 || i >= gE) continue;
            if (chosen.some(c => Math.abs(c - i) < 2 || Math.abs(wAt[c] - wAt[i]) < minW)) continue;
            if (gE - i < 2 || wAt[gE] - wAt[i] < minW) continue;
            const s = Math.abs(wAt[i] - t) - (i < kids.length && kinds[i] === 'h' ? minW * 0.3 : 0);
            if (s < bs) { bs = s; best = i; }
          }
          if (best >= 0) chosen.push(best);
        }
        chosen.push(gE);
      }
    }
    chosen.sort((a, b) => a - b);
    return { root, kids, start, mainEnd, faq, W, N, chosen, g1, gE, wAt };
  }

  /* ---------- putting it together ---------- */
  const MID = ['n', 'r', 'v', 'n', 'm', 's', 'r', 'v', 'n', 's'];
  const UNITS = [];
  let slotN = 0;
  function wrap(f, inner, ps) {
    const d = doc.createElement('div');
    d.className = 'dhbp-u dhbp-u--' + f;
    d.setAttribute('data-dhbp-f', f);
    d.setAttribute('data-dhbp-slot', String(++slotN));
    d.setAttribute('data-dhbp-ids', ids(ps));
    d.setAttribute('role', 'complementary');
    d.setAttribute('aria-label', LABEL + ' \u00b7 Divine Hindu');
    d.innerHTML = inner;
    UNITS.push(d);
    return d;
  }
  let sCount = 0, nCount = 0;
  function build(f) {
    if (f === 's') {
      sCount++;
      let topic = sCount === 1 ? T1 : (sCount === 2 && T2 ? T2 : null);
      if (topic && !topic.cols.length) topic = null;
      const nCols = topic ? Math.min(4, topic.cols.length) : 0;
      const ps = pick(topic ? 4 - nCols : 5);
      if (!topic && !ps.length) return null;
      return wrap('s', unitS(topic, ps), ps);
    }
    if (f === 'n') {
      nCount++;
      const ps = pickNear(1, p => p.c > p.p || p.g || p.free, 6);
      if (!ps.length) return null;
      return wrap('n', unitN(ps[0], kickerFor(ps[0])), ps);
    }
    if (f === 'r') {   // text-only lines: keep the items with videos and many pictures for the picture units
      const ps = pickPrefer(5, p => !p.v && p.x.length < 2, 14);
      return ps.length >= 3 ? wrap('r', unitR(ps), ps) : null;
    }
    if (f === 'v') {
      const ps = pickNear(4, p => !!p.v || p.x.length >= 2, 10);
      if (!ps.length) return null;
      const v = unitV(ps), el = wrap('v', v.html, ps);
      el.__slides = v.slides;
      return el;
    }
    if (f === 'm') { const ps = pick(4, p => !p.free); return ps.length >= 2 ? wrap('m', unitM(ps.slice(0, ps.length >= 4 ? 4 : 2), T1), ps) : null; }
    return null;
  }
  function placeInline(P) {
    const n = P.chosen.length;
    const seq = [];
    if (n >= 1) seq.push('s');
    for (let k = 1; k < n - 1; k++) seq.push(MID[(k - 1) % MID.length]);
    if (n >= 3 && seq[seq.length - 1] === 'm') seq[seq.length - 1] = ['s', 'r', 'v', 'n'].find(f => f !== seq[seq.length - 2]);   // no two grids in a row at the end
    if (n >= 2) seq.push('m');
    const atGap = P.chosen.map(() => []);
    seq.forEach((f, k) => atGap[k].push(f));
    // every one of the five in-article formats appears at least once: missing ones go before the last unit
    const need = ['s', 'n', 'r', 'v', 'm'].filter(f => seq.indexOf(f) < 0);
    if (n) { const last = atGap[n - 1]; last.splice(last.length - (seq.length >= 2 ? 1 : 0), 0, ...need); }
    const placed = [];
    P.chosen.forEach((gi, k) => {
      const ref = gi < P.kids.length ? P.kids[gi] : null;
      atGap[k].forEach(f => { const el = build(f); if (el) { P.root.insertBefore(el, ref); placed.push(el); } });
    });
    if (!n) {   // no usable gap: put them at the end of the article text
      const ref = P.kids[P.mainEnd] || null;
      ['s', 'n', 'r', 'v', 'm'].forEach(f => { const el = build(f); if (el) { P.root.insertBefore(el, ref); placed.push(el); } });
    }
    return placed;
  }

  /* ---------- motion / video ---------- */
  function startMotion(u) {
    const box = u.querySelector('.dhbp-v');
    if (!box) return;
    const mode = box.getAttribute('data-mode');
    const vid = box.querySelector('video');
    const slides = u.__slides || [];
    let timer = null, k = 0;
    const show = j => {
      k = (j + slides.length) % slides.length;
      box.querySelectorAll('.dhbp-v__sl').forEach(s => s.classList.toggle('is-on', +s.getAttribute('data-k') === k));
      box.querySelectorAll('.dhbp-v__prog i').forEach(s => { const sk = +s.getAttribute('data-k'); s.classList.toggle('is-done', sk < k); s.classList.toggle('is-on', sk === k); });
      const p = slides[k] && slides[k].p;
      if (p && slides.some(s => s.p !== slides[0].p)) {   // a slide per product: the caption and bar follow it
        const a = box.querySelector('.dhbp-v__f'), bar = box.querySelector('.dhbp-v__bar');
        const url = link(p.u, 'v');
        a.href = url; a.setAttribute('data-id', p.id);
        box.querySelector('.dhbp-v__cap').textContent = shortT(p, 60);
        const th = bar.querySelector('.dhbp-v__th'); th.innerHTML = imgTag(p.i, [120, 180], '48px');
        bar.querySelector('.dhbp-v__tx b').textContent = shortT(p, 70);
        bar.querySelector('.dhbp-v__tx span').innerHTML = priceHTML(p);
        const btn = bar.querySelector('.dhbp-btn'); btn.href = url; btn.setAttribute('data-id', p.id); btn.textContent = cta(p);
      }
    };
    const play = () => {
      if (mode === 'video' && vid) { if (!REDUCED) { const pr = vid.play(); if (pr && pr.catch) pr.catch(() => {}); } box.classList.add('is-playing'); return; }
      if (REDUCED || slides.length < 2 || timer) return;
      box.classList.add('is-playing');
      show(k);
      timer = setInterval(() => show(k + 1), 2800);
    };
    const stop = () => {
      if (vid) vid.pause();
      box.classList.remove('is-playing');
      if (timer) { clearInterval(timer); timer = null; }
    };
    if ('IntersectionObserver' in win) {
      new IntersectionObserver(es => es.forEach(e => (e.isIntersecting && e.intersectionRatio >= 0.55 ? play() : stop())), { threshold: [0, 0.55] }).observe(box);
    } else play();
  }

  /* ---------- measuring (Google Analytics and Shopify customer events) ---------- */
  function send(name, el, oneId) {
    const f = el.getAttribute('data-dhbp-f') || '', slot = el.getAttribute('data-dhbp-slot') || '0';
    const list = oneId ? [oneId] : (el.getAttribute('data-dhbp-ids') || '').split(',').filter(Boolean);
    const items = list.map(id => {
      if (id.indexOf('c:') === 0) return { item_id: id, item_name: 'Collection ' + id.slice(2) };
      const p = BY.get(id);
      return p ? { item_id: id, item_name: p.t, price: p.p, item_category: p.ty } : null;
    }).filter(Boolean);
    const payload = { promotion_id: 'dhbp_' + f, promotion_name: 'Blog picks: ' + (T1 ? T1.l : 'Divine Hindu'), creative_name: FN[f] || f, creative_slot: slot, items };
    try {
      if (typeof win.gtag === 'function') win.gtag('event', name, payload);
      else if (Array.isArray(win.dataLayer)) { win.dataLayer.push({ ecommerce: null }); win.dataLayer.push({ event: name, ecommerce: payload }); }
    } catch (e) { /* analytics not ready */ }
    try {
      const sa = win.Shopify && win.Shopify.analytics;
      if (sa && typeof sa.publish === 'function') sa.publish(name === 'select_promotion' ? 'dh_blog_pick_click' : 'dh_blog_pick_view', Object.assign({ article: ART.h || '' }, payload));
    } catch (e) { /* ignore */ }
  }
  const viewed = new WeakSet();
  const io = 'IntersectionObserver' in win ? new IntersectionObserver(es => es.forEach(e => {
    const el = e.target;
    if (e.isIntersecting && e.intersectionRatio >= 0.5) {
      if (!el.__dhbpT) el.__dhbpT = setTimeout(() => { if (!viewed.has(el)) { viewed.add(el); send('view_promotion', el); io.unobserve(el); } }, 1000);
    } else if (el.__dhbpT) { clearTimeout(el.__dhbpT); el.__dhbpT = null; }
  }), { threshold: [0, 0.5] }) : null;
  const watch = el => { if (io) io.observe(el); };

  /* ---------- floating pieces: bar, pop-up, side panel ---------- */
  let BAR = null, SHEET = null, RAIL = null, P = null, firstUnit = null;
  let fabPrev = null, fabLift = 0;
  const bubble = () => doc.getElementById('dhb-bubble');
  function setLift(px) {
    if (px === fabLift) return;
    if (fabPrev === null) fabPrev = html.style.getPropertyValue('--dh-fab-bottom') || '';
    fabLift = px;
    if (px) html.style.setProperty('--dh-fab-bottom', px + 'px');
    else if (fabPrev) html.style.setProperty('--dh-fab-bottom', fabPrev);
    else html.style.removeProperty('--dh-fab-bottom');
  }
  const visible = el => { if (!el) return false; const cs = getComputedStyle(el); return cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0; };
  function bottomInset(left, right) {
    const vh = win.innerHeight;
    let minTop = vh;
    doc.querySelectorAll('.dh-bottomnav,[class*="bottomnav"],[class*="bottom-nav"],[class*="tabbar"],[class*="sticky-atc"],[class*="mobile-nav-bar"]').forEach(e => {
      if (e.closest('.dhbp-a,.dhbp-sheet')) return;
      const cs = getComputedStyle(e);
      if ((cs.position !== 'fixed' && cs.position !== 'sticky') || cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return;
      const r = e.getBoundingClientRect();
      if (!r.width || !r.height || r.height > 160 || r.top >= vh || r.bottom < vh - 160) return;
      if (r.width >= 120 && r.right > left && r.left < right) minTop = Math.min(minTop, r.top);
    });
    return minTop < vh ? Math.round(vh - minTop + 8) : 0;
  }
  function overlayOpen() {
    const c = (doc.body.className || '') + ' ' + (html.className || '');
    if (/(overflow-hidden|no-scroll|drawer-open|modal-open|menu-open|search-open|is-locked|scroll-lock)/i.test(c)) return true;
    const cs = getComputedStyle(doc.body);
    if (cs.overflow === 'hidden' || cs.position === 'fixed') return true;
    const ae = doc.activeElement;
    return !!(ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName));
  }
  let HDR;
  function headerEl() {   // the sticky or fixed header, found once
    if (HDR !== undefined) return HDR;
    HDR = null;
    let best = 0;
    const pos = e => getComputedStyle(e).position;
    doc.querySelectorAll('.shopify-section-group-header-group, #shopify-section-header, sticky-header, header, .header-wrapper, [class*="site-header"]').forEach(e => {
      const p = pos(e);
      if (p !== 'sticky' && p !== 'fixed') return;
      const r = e.getBoundingClientRect();
      if (r.top <= 4 && r.bottom > best && r.bottom < win.innerHeight / 2) { best = r.bottom; HDR = e; }
    });
    if (!HDR) {
      let e = doc.elementFromPoint(win.innerWidth / 2, 2);
      while (e && e !== doc.body) { const p = pos(e); if (p === 'sticky' || p === 'fixed') { HDR = e; break; } e = e.parentElement; }
    }
    return HDR;
  }
  function articleBox() { const r = P.root.getBoundingClientRect(); return { top: r.top, bottom: r.bottom, left: r.left, right: r.right, h: r.height }; }

  function mountBar() {
    if (CFG.bar === false || store.get('dhbp-bar') === 'x') return;
    const p = pick(1)[0];
    if (!p) return;
    const el = doc.createElement('div');
    el.className = 'dhbp-a';
    el.setAttribute('data-dhbp-f', 'a'); el.setAttribute('data-dhbp-slot', String(++slotN)); el.setAttribute('data-dhbp-ids', p.id);
    el.setAttribute('role', 'complementary'); el.setAttribute('aria-label', LABEL + ' \u00b7 Divine Hindu');
    const u = esc(link(p.u, 'a')), id = esc(p.id);
    el.innerHTML = `<span class="dhbp-a__l">${esc(LABEL)}</span><a class="dhbp-a__m" href="${u}" data-id="${id}"><span class="dhbp-a__im">${imgTag(p.i, [120, 180], '48px')}</span><span class="dhbp-a__t"><b>${esc(T1 ? T1.l : 'Divine Hindu')}</b><span>${esc(shortT(p, 44))} \u00b7 ${p.free ? 'Free' : esc(money(p.p))}</span></span></a><a class="dhbp-btn" href="${u}" data-id="${id}">${esc(cta(p))}</a><button type="button" class="dhbp-x" aria-label="Close">\u00d7</button>`;
    doc.body.appendChild(el);
    BAR = el;
    watch(el);
  }
  function mountSheet() {
    const x = +store.get('dhbp-sheet-x') || 0;   // after "Not now" or close, rest for 20 minutes
    if (CFG.popup === false || Date.now() - x < 20 * 60e3) return;
    const p = POOL.find(q => !q.free || (T1 && T1.k === 'astrology'));   // the closest match, even if shown above
    if (!p) return;
    const col = T1 && T1.cols[0];
    const useOffer = OFFER && SHARE <= 0.5 && !(T1 && T1.k === 'astrology');
    const head = useOffer ? OFFER : (T1 ? T1.h : shortT(p, 80));
    const body = T1 ? T1.d : sentence(p.d, 140);
    const href = col ? link(col.u, 'p') : link(p.u, 'p');
    const go = col ? (pujaLed() ? 'Book ' : 'Shop ') + col.l : cta(p);
    const el = doc.createElement('div');
    el.className = 'dhbp-sheet';
    el.hidden = true;
    el.setAttribute('data-dhbp-f', 'p'); el.setAttribute('data-dhbp-slot', String(++slotN)); el.setAttribute('data-dhbp-ids', col ? 'c:' + col.h + ',' + p.id : p.id);
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'false'); el.setAttribute('aria-label', LABEL + ' \u00b7 Divine Hindu');
    el.innerHTML = `<div class="dhbp-sheet__grab"></div><button type="button" class="dhbp-x" aria-label="Close">\u00d7</button>${tag()}
<a class="dhbp-sheet__row" href="${esc(href)}" data-id="${esc(col ? 'c:' + col.h : p.id)}"><span class="dhbp-sheet__im">${imgTag(p.i, [240, 360], '96px')}</span><span class="dhbp-sheet__tx"><b>${esc(head)}</b><span>${esc(body)}</span></span></a>
<a class="dhbp-btn dhbp-sheet__go" href="${esc(href)}" data-id="${esc(col ? 'c:' + col.h : p.id)}">${esc(go)}</a><button type="button" class="dhbp-sheet__no">Not now</button>`;
    doc.body.appendChild(el);
    SHEET = el;
  }
  function mountRail() {
    if (CFG.rail === false || win.innerWidth < 1200) return;
    const p = pick(1)[0];
    if (!p) return;
    const el = doc.createElement('div');
    el.className = 'dhbp-rail';
    el.setAttribute('data-dhbp-f', 'l'); el.setAttribute('data-dhbp-slot', String(++slotN)); el.setAttribute('data-dhbp-ids', p.id);
    el.setAttribute('role', 'complementary'); el.setAttribute('aria-label', LABEL + ' \u00b7 Divine Hindu');
    const u = esc(link(p.u, 'l')), id = esc(p.id);
    const pts = p.free ? ['Free scan from a photo', 'Main lines marked on your palm', 'Detailed report is optional']
      : p.g ? ['Booked online', 'Your name and gotra in the sankalp']
        : ['Delivery across India', 'Cash on delivery available'].concat(OFFER && SHARE <= 0.5 ? [OFFER] : []);
    el.innerHTML = `${tag()}<a class="dhbp-rail__im" href="${u}" data-id="${id}" tabindex="-1" aria-hidden="true">${imgTag(p.i, [360, 540], '280px')}${off(p) >= 10 ? `<span class="dhbp-n__pill">${off(p)}% off</span>` : ''}</a>
<div class="dhbp-rail__b"><div class="dhbp-n__k">${esc(T1 ? T1.l : 'Divine Hindu')}</div><a class="dhbp-rail__t" href="${u}" data-id="${id}">${esc(shortT(p, 80))}</a><div class="dhbp-rail__p">${priceHTML(p)}</div>
<p>${esc(sentence(p.d, 120))}</p><ul>${pts.map(t => `<li>${esc(t)}</li>`).join('')}</ul><a class="dhbp-btn" href="${u}" data-id="${id}">${esc(cta(p))}</a></div>`;
    doc.body.appendChild(el);
    RAIL = el;
  }

  let sheetOpen = false, sheetY = null, sheetAt = 0, sheetDone = false, ticking = false, idleT = null, lastScroll = 0;
  function openSheet() {
    if (!SHEET || sheetOpen || sheetDone || overlayOpen()) return;
    sheetOpen = true; sheetDone = true; sheetY = null; sheetAt = Date.now();
    SHEET.hidden = false;
    requestAnimationFrame(() => SHEET.classList.add('is-in'));
    send('view_promotion', SHEET);
    update();
  }
  function closeSheet(byReader) {
    if (!SHEET || !sheetOpen) return;
    sheetOpen = false;
    if (byReader) store.set('dhbp-sheet-x', String(Date.now()));
    SHEET.classList.remove('is-in');
    setTimeout(() => { SHEET.hidden = true; update(); }, 260);
    update();
  }
  function update() {
    ticking = false;
    if (!P) return;
    const vw = win.innerWidth, vh = win.innerHeight, a = articleBox();
    let lift = 0;
    const bb = bubble(), br = bb && visible(bb) ? bb.getBoundingClientRect() : null;
    // bar
    if (BAR) {
      const past = firstUnit ? firstUnit.getBoundingClientRect().bottom < 0 : win.scrollY > 600;
      const show = past && !sheetOpen && a.bottom > vh * 0.6 && !overlayOpen();
      BAR.classList.toggle('is-in', show);
      if (show) {
        const r = BAR.getBoundingClientRect();
        const ins = bottomInset(r.left, r.right);
        BAR.style.bottom = ins ? ins + 'px' : '';
        BAR.classList.toggle('is-free', !ins);
        const top = vh - (ins || 10) - r.height;
        if (br && br.right > r.left && br.left < r.right) lift = Math.max(lift, Math.round(vh - top + 8));
      }
    }
    // pop-up
    if (sheetOpen && SHEET) {
      const r = SHEET.getBoundingClientRect();
      if (br && br.right > r.left && br.left < r.right) lift = Math.max(lift, Math.round(vh - r.top + 10));
      // gently away: once it has been on screen for 3 s, two more screens of scrolling put it away
      if (Date.now() - sheetAt > 3000) {
        if (sheetY === null) sheetY = win.scrollY;
        else if (Math.abs(win.scrollY - sheetY) > vh * 2) closeSheet();
      }
    }
    setLift(lift);
    // side panel
    if (RAIL) {
      const room = vw - a.right;
      const w = Math.min(300, room - 44);
      let top = 96;
      const hdr = headerEl();
      if (hdr) { const hr = hdr.getBoundingClientRect(); if (hr.bottom > 0 && hr.bottom < vh / 2) top = Math.round(hr.bottom + 20); }
      const rh = RAIL.offsetHeight || 460;
      const show = vw >= 1200 && w >= 200 && a.top < vh * 0.35 && a.bottom > top + rh + 40 && !overlayOpen();
      RAIL.classList.toggle('is-in', show);
      if (show && !RAIL.__w) { RAIL.__w = 1; watch(RAIL); }
      if (show) { RAIL.style.width = Math.round(w) + 'px'; RAIL.style.left = Math.round(a.right + 22) + 'px'; RAIL.style.top = top + 'px'; }
    }
    // pop-up trigger: about halfway through the article, or 35 s of reading with some scrolling
    if (SHEET && !sheetDone && a.h > 0 && Date.now() - T0 > 6000) {
      const depth = (vh - a.top) / a.h;
      // opens when the reader pauses (no scrolling for 0.7 s) about halfway down, or after 35 s with some scrolling
      if ((depth >= 0.5 || (Date.now() - T0 > 35000 && depth >= 0.25)) && Date.now() - lastScroll >= 700) openSheet();
    }
  }
  const onScroll = () => {
    lastScroll = Date.now();
    clearTimeout(idleT); idleT = setTimeout(update, 750);   // one more look once scrolling stops
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  };

  function wire() {
    win.addEventListener('scroll', onScroll, { passive: true });
    win.addEventListener('resize', onScroll);
    setInterval(() => { if ((BAR && BAR.classList.contains('is-in')) || sheetOpen) update(); }, 400);
    setTimeout(update, 800);
    doc.addEventListener('click', e => {
      const t = e.target;
      const info = t.closest && t.closest('.dhbp-i');
      if (info) {
        e.preventDefault();
        const host = info.closest('.dhbp-u,.dhbp-sheet,.dhbp-rail');
        const why = host && host.querySelector('.dhbp-why');
        if (why) { why.hidden = !why.hidden; info.setAttribute('aria-expanded', String(!why.hidden)); }
        return;
      }
      if (t.closest && t.closest('.dhbp-a .dhbp-x')) { e.preventDefault(); store.set('dhbp-bar', 'x'); BAR.remove(); BAR = null; update(); return; }
      if (t.closest && t.closest('.dhbp-sheet .dhbp-x, .dhbp-sheet__no')) { e.preventDefault(); closeSheet(true); return; }
      const a = t.closest && t.closest('a[data-id]');
      if (a) {
        const host = a.closest('[data-dhbp-f]');
        if (host) send('select_promotion', host, a.getAttribute('data-id'));
      }
    }, true);
    doc.addEventListener('keydown', e => { if (e.key === 'Escape' && sheetOpen) closeSheet(true); });
    doc.addEventListener('mouseout', e => {   // leaving the page on a computer
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - T0 > 8000 && win.innerWidth >= 1024) openSheet();
    });
  }

  /* ---------- start ---------- */
  function cssReady(cb) {
    const l = doc.getElementById('dhbp-css');
    if (!l || (l.media !== 'print' && l.sheet)) return cb();
    let done = false;
    const go = () => { if (!done) { done = true; cb(); } };
    l.addEventListener('load', () => setTimeout(go, 0));
    const t = setInterval(() => { if (l.media !== 'print' && l.sheet) { clearInterval(t); go(); } }, 100);
    setTimeout(() => { clearInterval(t); go(); }, 3000);
  }
  function run(hits) {
    try {
      buildPool(hits);
      window.__dhbp.state = 'pool';
      if (!POOL.length) { window.__dhbp.state = 'empty'; return; }
      const info = findRoot();
      if (!info) { window.__dhbp.state = 'no-article'; return; }
      P = plan(info);
      mountRail();   // wide screens only: the side panel gets the closest match
      const placed = placeInline(P);
      firstUnit = placed[0] || null;
      placed.forEach(u => { watch(u); if (u.getAttribute('data-dhbp-f') === 'v') startMotion(u); });
      mountBar();
      mountSheet();
      wire();
      update();
      Object.assign(window.__dhbp, {
        state: 'ready', t1: T1 && T1.k, t2: T2 && T2.k, words: P.W, target: P.N, gaps: P.chosen.length,
        inline: placed.map(u => u.getAttribute('data-dhbp-f')).join(''), pool: POOL.length, hits: (hits || []).length,
        share: Math.round(SHARE * 100) / 100, ms: Date.now() - T0
      });
    } catch (err) {
      window.__dhbp.state = 'error';
      window.__dhbp.error = String(err && err.message || err);
    }
  }
  const qs = CFG.search === false ? [] : queries();
  const searching = qs.length && win.fetch ? Promise.all(qs.map(suggest)).then(r => [].concat.apply([], r)) : Promise.resolve([]);
  const timeout = new Promise(r => setTimeout(() => r(null), 2500));
  cssReady(() => Promise.race([searching, timeout]).then(h => run(h || [])));
})();
